<template lang="pug">
  .root
    component-header-index(v-if="$store.state.user.email")
    component-header-login(v-if="!$store.state.user.email")
    div(class="container-flex")
      div(class="content-info")
        <h3 style="text-align:center">特定商取引法に基づく表記</h3>

        div(class="term-content")
          <div v-html="text"></div>



    component-footer-index(v-if="$store.state.user.email")
    component-footer-login(v-if="!$store.state.user.email")
</template>

<style src="./Tokushoho.scss" lang="scss" scoped>
</style>

<script>
import { getStaticNotation } from '@/api/system';

export default {
  name: "TopBroadcastIndex",
  components: {
  },
  data() {
    return {
      ui: {
      },
      oneNewsInfo: {

      },
      text: '',
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {
    const res = await getStaticNotation();
    this.text = res.notation.content.describe;
  },
  updated() {},
  destroyed() {},
  methods: {
  }
};
</script>
